APP.locations = function () {
	const dataLocations = [
		{
			areaName: 'Miền Bắc',
			areaSlug: 'mien-bac',
			cityName: 'Hà Nội',
			citySlug: 'ha-noi',
			address: 'Số 01 Nguyễn Văn Linh, Phường Gia Thuỵ, Quận Long Biên, Thành Phố Hà Nội, Việt Nam',
			time: '08h00 sáng 03/04/2023',
			phone: '0909000001',
		},
		{
			areaName: 'Miền Bắc',
			areaSlug: 'mien-bac',
			cityName: 'Hải Dương',
			citySlug: 'hai-duong',
			address: 'Số 02 Nguyễn Văn Linh, Phường Gia Thuỵ, Quận Long Biên, Thành Phố Hà Nội, Việt Nam',
			time: '08h00 sáng 04/04/2023',
			phone: '0909000002',
		},
		{
			areaName: 'Miền Bắc',
			areaSlug: 'mien-bac',
			cityName: 'Hà Nội',
			citySlug: 'ha-noi',
			address: 'Số 04 Nguyễn Văn Linh, Phường Gia Thuỵ, Quận Long Biên, Thành Phố Hà Nội, Việt Nam',
			time: '08h00 sáng 05/04/2023',
			phone: '0909000005',
		},
		{
			areaName: 'Miền Trung',
			areaSlug: 'mien-trung',
			cityName: 'Đà Nẵng',
			citySlug: 'da-nang',
			address: 'Số 021 Nguyễn Văn Linh, Phường 01, Quận Sơn Trà, Thành Phố Đà Nẵng, Việt Nam',
			time: '08h00 sáng 04/03/2023',
			phone: '0909000003',
		},
		{
			areaName: 'Miền Nam',
			areaSlug: 'mien-nam',
			cityName: 'Thành Phố Hồ Chí Minh',
			citySlug: 'thanh-pho-ho-chi-minh',
			address: 'Số 01 Hải Triều, Thành Phố Hồ Chí Minh, Việt Nam',
			time: '08h00 sáng 04/03/2023',
			phone: '0909000004',
		},
	];
	const el = $('.locations');
	const region = el.find('.region');
	const regionLabelText = region.data('label-region');
	const regionList = region.find('.region__list');
	const regionSelect = el.find('[name="region"]');
	const citySelect = el.find('[name="city"]');
	const citySelectLabel = citySelect.data('label-city');

	function init() {
		if (el.length === 0) return;

		citySelect.on('change', handleSelectCity);
		handleInitialLoad();
	}

	function getAreas(data) {
		const areas = [...new Map(data.map((item) => [item['areaSlug'], item])).values()];
		return areas;
	}

	function getProvinces(data) {
		const provinces = [...new Map(data.map((item) => [item['citySlug'], item])).values()];
		return provinces;
	}

	function renderAreas(data) {
		let menuItems = [
			`<div class="region__item is-active" data-value="all">${regionLabelText}</div>`,
		];
		let items = [`<option selected value="all">${regionLabelText}</option>`];

		data.forEach((item) => {
			items.push(`<option value="${item.areaSlug}">${item.areaName}</option>`);
			menuItems.push(
				`<div class="region__item" data-value="${item.areaSlug}">${item.areaName}</div>`
			);
		});

		regionList.html(menuItems.join(''));
		regionSelect.html(items.join(''));
		regionSelect.select2('destroy');
		regionSelect.select2({
			with: 'resolve',
			templateSelection: function (data, container) {
				if (data.id !== '') {
					$(container).addClass('select2-selection__rendered--value');
				} else {
					$(container).removeClass('select2-selection__rendered--value');
				}
				return data.text;
			},
		});

		const areaMenuItem = regionList.find('.region__item');

		areaMenuItem.on('click', handleClickArea);
		regionSelect.on('change', handleChangeArea);
	}

	function handleClickArea(e) {
		const obj = $(this);
		const areaSlug = obj.data('value');

		$('.region__item').removeClass(CLASS._active);
		obj.addClass(CLASS._active);

		regionSelect.val(areaSlug);
		regionSelect.select2('destroy');
		regionSelect.select2({
			with: 'resolve',
			templateSelection: function (data, container) {
				if (data.id !== '') {
					$(container).addClass('select2-selection__rendered--value');
				} else {
					$(container).removeClass('select2-selection__rendered--value');
				}
				return data.text;
			},
		});

		renderChangeAreaToDom(areaSlug);
	}

	function handleChangeArea(e) {
		const obj = $(this);
		const areaSlug = obj.val();

		$('.region__item').removeClass(CLASS._active);
		$('.region__item[data-value="' + areaSlug + '"]').addClass(CLASS._active);

		renderChangeAreaToDom(areaSlug);
	}

	function renderChangeAreaToDom(areaSlug) {
		if (areaSlug !== 'all') {
			const data = dataLocations.filter((item) => item.areaSlug === areaSlug);

			const cities = getProvinces(data);

			renderSelectCity(cities);
			renderLocationsToDom(data);
		} else {
			renderSelectCity(dataLocations);
			renderLocationsToDom(dataLocations);
		}
	}

	function renderSelectCity(data) {
		let items = [`<option selected value="all">${citySelectLabel}</option>`];

		data.forEach((item) => {
			items.push(`<option value="${item.citySlug}">${item.cityName}</option>`);
		});

		citySelect.html(items.join(''));
		citySelect.select2('destroy');
		citySelect.select2({
			with: 'resolve',
			templateSelection: function (data, container) {
				if (data.id !== '') {
					$(container).addClass('select2-selection__rendered--value');
				} else {
					$(container).removeClass('select2-selection__rendered--value');
				}
				return data.text;
			},
		});
	}

	function handleSelectCity(e) {
		const obj = $(this);
		const citySlug = obj.val();
		const areaSlug = regionSelect.val();

		renderChangeSelectToDom(citySlug, areaSlug);
	}

	function renderChangeSelectToDom(citySlug, areaSlug) {
		let data = '';
		if (citySlug !== 'all') {
			data = dataLocations.filter((item) => item.citySlug === citySlug);
		} else {
			data = dataLocations.filter((item) => item.areaSlug === areaSlug);
		}
		renderLocationsToDom(data);
	}

	function renderLocationItem(data) {
		const { cityName, address, time, phone } = data;

		return `<tr>
			<td scope="row">${cityName}</td>
			<td>${address}</td>
			<td>${time}</td>
			<td>${phone}</td>
		</tr>
		`;
	}

	function renderLocationsToDom(data) {
		let items = data.map((item) => renderLocationItem(item));
		$('.locations__body table tbody').html(items);
	}

	function handleInitialLoad() {
		const areas = getAreas(dataLocations);
		const cities = getProvinces(dataLocations);

		renderAreas(areas);
		renderSelectCity(cities);
		renderLocationsToDom(dataLocations);
	}

	init();
};
